import React from 'react';
import mixpanel from 'mixpanel-browser';
import { blogTitle } from '../../constants/Footer/blog';

import './Blog.css';

export const BlogCard = ({ title, description, imageUrl, link, date }) => {
  return (
    <>
      <div className="blog-card">
        <img src={imageUrl} alt={title} height="300" className="blogImage" />
        <div className="blogContent">
          <h3 className="blogTitle">{title}</h3>
          <p className="blogDate">{date}</p>
          <p className="blogDescription">{description}</p>
          <a
            href={link}
            className="blogLink"
            onClick={() =>
              mixpanel.track('Blog Read More Link Clicked', {
                blog_link: link,
              })
            }
          >
            {blogTitle.ReadMoreLink}
          </a>
        </div>
      </div>
    </>
  );
};
